<template>
  <div class="custom-collect-index-container scrollbar">
    <div class="custom-collect-index-back">
      <el-button @click="goBack" type="primary"><jee-icon iconClass="fanhui"></jee-icon> 返回</el-button>
    </div>
    <div class="custom-collect-index-tabs">
      <el-tabs v-model="customTabsName" :before-leave="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" :key="index" v-for="(item, index) in customTabs">
          <component :is="item.component" :custom-name="customTabsName" @change-model-fields="changeModelFields" :model-fields="modelFields" @change-name="setCustomTabName" v-model="collectForm" :collect-type="collectType" :linkName='linkName'></component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BasicInfo from './components/BasicInfo'
import CollectDispose from './components/CollectDispose'
export default {
  name: 'Index',
  data () {
    return {
      linkName: '',
      customTabsName: 'basic', // tab 选中项
      collectType: 'add', // 采集类型
      customTabs: [ // tab 选项
        {
          label: '基本信息',
          name: 'basic',
          component: 'BasicInfo'
        },
        {
          label: '采集配置',
          name: 'dispose',
          component: 'CollectDispose'
        }
      ],
      modelFields: [], // 字段列表
      collectForm: {
        name: '', // 任务名称
        url: '', // 采集网站
        channelId: '', // 栏目
        modelId: '', // 内容模型
        endPage: '', // 采集结束页数
        pageSet: 1, // 分页设置（ 1不分页2自动识别3手动识别4识别瀑布流分页）
        pageXpath: '', // 分页Xpath
        startPage: '', // 采集起始页数
        startPoint: 1, // 采集起点（1从第一条开始，2从最后一条开始）
        urlDynamic: '' // 采集动态地址
      } // 采集信息
    }
  },
  components: {
    BasicInfo,
    CollectDispose
  },
  mounted () {
    // 判断是否有 taskId, 如果有请求接口获取详情，如果没有初始化配置页面
    if (this.$route.query.taskId !== undefined) {
      this.collectType = 'edit'
      this.getCollectDetail(this.$route.query.taskId)
    }
  },
  methods: {
    // 判断是否为空
    isEmpty (value) {
      let isTrue = true
      if (value instanceof Array) {
        if (value.length === 0) {
          isTrue = false
        }
      } else {
        if (value === '') {
          isTrue = false
        }
      }
      return isTrue
    },
    // 点击切换
    handleClick (activeName, oldActiveName) {
      let isTrue = true
      // 判断是否是切换基本信息
      if (activeName === 'dispose') {
        // 验证基础信息是否为空
        for (let i in this.collectForm) {
          if (i === 'name' || i === 'url' || i === 'fieldIds' || i === 'channelId' || i === 'modelId') {
            isTrue = this.isEmpty(this.collectForm[i])
          }
          if (!isTrue) {
            break
          }
        }
      }
      // 如果是false，弹出提示语句
      if (!isTrue) {
        this.$message.error('基本信息不能为空')
      }
      return isTrue
    },
    goBack () {
      if(this.collectType = 'edit' || window.location.href.includes('See')) {
        window.history.back()
      }else {
      this.$router.go(-1)
      }
    },
    setCustomTabName (name) {
      this.customTabsName = name
    },
    changeModelFields (value) {
      this.modelFields = value
    },
    // 获取采集任务详情
    getCollectDetail (id) {
      this.$request.fetchCollectTaskExtDetail(id).then(res => {
        if (res.code === 200) {
          console.log(res,'获取采集任务详情');
          this.collectForm = res.data
          this.linkName = res.data.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.custom-collect-index-container{
  .custom-collect-index-back{
    margin-bottom: 20px;
    .el-button{
      font-size:16px;
      width: 90px;
      padding: 9px 0;
    }
    .jee-svg-icon{
      vertical-align: -0.1em;
      font-size: 14px;
    }
  }
}
</style>
